import { MembershipDetailsPage } from '@/imports/ui/pages/user/MembershipDetailsPage';
import { restrictedRoute } from '@/utilities/restrictedRoute';

export default restrictedRoute(
  MembershipDetailsPage,
  {
    requiresEvery: [],
  },
  { requiresMemberManagement: true }
);
